import {Component, Input, OnInit, AfterViewInit, Output, OnDestroy} from '@angular/core';
import {ServiceService} from "../../services/service.service";



import {PagerDataObject} from "../../entities/pagerDataObject";

import {Service} from "../../entities/service";
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.css']
})
export class ServiceListComponent implements OnInit {

 
  metaInfo: string[];
  columns: Array<any>;
  data: PagerDataObject;
  @Input()
  headers = [' ', 'Name', 'Code', 'Type'];
  @Input()
  disableHeader = false;
  subscription: any;
  private dataSub$ = new Subject<any>();
  query: String;

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  constructor(private serviceService: ServiceService) {
    this.subscription = this.dataSub$.pipe(switchMap(filter => {
      return this.serviceService.getData(filter);
    }))
      .subscribe(data => {
        this.data = data;
      });
    this.metaInfo = this.serviceService.getMetaInfo();
    this.columns = this.serviceService.getColumns();
  }

  onGridQuery(query) {
    this.query = query
    this.dataSub$.next(query);
  }

  deleteService(entity){
    let service = new Service();
    service.id = entity;
    this.serviceService.delete(service)
      .subscribe(service => {
        this.dataSub$.next(this.query);
      });
  }

}
